import { useLang } from '../hooks/useLang';
import FeedbackForm from '../components/FeedbackForm';
import './About.css';

export default function About() {
    const [lang] = useLang();

    if (lang === 'ta') {
        return (
            <article className="about" lang="ta">
                <header className="about__head">
                    <h1 className="about__title">ஏன் இந்த முயற்சி?</h1>
                </header>

                <section className="about__prose" aria-label="தோற்றம்">
                    <p>
                        குறளுக்கு நடுவிலேயே வளர்ந்தேன்; ஆனால் அதை
                        உண்மையில் படித்ததில்லை. பல தமிழ்ப் பிள்ளைகளைப்
                        போலவே, பள்ளியில் கேட்ட அதே பத்துப் பன்னிரண்டு குறள்களை
                        வைத்து, முழு நூலும் தெரிந்திருப்பதாக நினைத்துக்
                        கொண்டிருந்தேன். ஒருநாள் அமர்ந்து முழுமையாகப்
                        படிக்கத் தொடங்கியபோதுதான் புரிந்தது — நான் இழந்திருந்தது
                        எவ்வளவு என்று.
                    </p>
                    <p>
                        குறள் இத்தனை காலம் வாழ்ந்திருப்பதற்குக் காரணம், மக்கள்
                        அதனிடம் திரும்பி வருவதை நிறுத்தவே இல்லை என்பதுதான்.
                        ஒவ்வொரு நூற்றாண்டும் தனக்கென உரையாசிரியர்களையும்
                        மொழிபெயர்ப்பாளர்களையும் வாசகர்களையும் உருவாக்கியது; ஒவ்வொரு
                        தலைமுறையும் முந்தையது காணாத ஒன்றைக் கண்டுபிடித்தது. இந்தத்
                        தளமும் அதே மரபின் தொடர்ச்சிதான் — அவர்களின் கருவிகளுக்குப்
                        பதிலாக, என் தலைமுறையின் கருவிகளுடன்.
                    </p>
                    <p>
                        இது ஒரு புலமைத் திட்டமல்ல. நிறுவனம் இல்லை, நிதி இல்லை, குழு
                        இல்லை. ஓய்வு நேரங்களும், இரண்டாயிரம் ஆண்டு மூத்த நூலின் மேல்
                        இன்றைய கருவிகளைத் திருப்பினால் என்ன நிகழும் என்ற தணியாத
                        ஆர்வமும் — இவ்வளவுதான் மூலதனம். எனக்காகவே இதை உருவாக்கினேன்;
                        வேறு யாருக்காவது பயன்பட்டால், அது கூடுதல் மகிழ்ச்சி.
                    </p>
                </section>

                <p className="about__note">
                    இங்குப் பயன்படுத்தப்படும் நூல்கள், காலம் அனைவருக்கும்
                    பொதுவாக்கிவிட்டவை — மூலக் குறள்களும், பொதுக்களத்தில் உள்ள பழைய
                    உரைகளும்.
                </p>

                <section className="about__section" aria-labelledby="about-now">
                    <h2 id="about-now" className="about__section-title">
                        இப்போது இங்கே இருப்பது
                    </h2>
                    <p className="about__section-lede">
                        1,330 குறள்களின் ஊடாடும் வரைபடம். ஒவ்வொரு குறளையும் ஒரு LLM
                        வாசித்து, அது தொடும் கருத்துக்களை இனங்கண்டு குறியிட்டுள்ளது;
                        அந்தக் கருத்துப் பகிர்வின் அளவுக்கு ஏற்பக் குறள்களை வரைபடம்
                        இணைக்கிறது — ஒரே அதிகாரத்து அண்டை குறள்கள் ஒரு வழியிலும்,
                        அதிகாரங்களைக் கடந்த கருத்து உறவினர்கள் இன்னொரு வழியிலும்.
                        முழுத் தொகுப்பும் Google-இன் Open Knowledge Format (OKF)
                        வடிவில் அமைந்துள்ளது — அடிப்படைத் தரவுகள் எந்தத் தரவுத்தளத்திலும்
                        பூட்டப்படாமல், யார் வேண்டுமானாலும் படிக்க, பகிர, மேம்படுத்தக்கூடிய
                        எளிய markdown கோப்புகளாகவே வாழ்கின்றன.
                    </p>
                </section>

                <section className="about__section" aria-labelledby="about-coming">
                    <h2 id="about-coming" className="about__section-title">
                        வரவிருப்பவை
                    </h2>
                    <ul className="about__features">
                        <li className="about__feature">
                            <strong className="about__feature-lead">
                                உரையாசிரியர்கள், அருகருகே.
                            </strong>{' '}
                            எஞ்சியிருக்கும் ஐந்து பழைய உரைகளும் குறள்தோறும் ஒப்பிட்டு
                            அமைக்கப்படும் — எங்கே உடன்படுகிறார்கள், எங்கே அமைதியாக வழி
                            பிரிகிறார்கள் என்ற பகுப்பாய்வுடன். எழுநூறு ஆண்டு உரை மரபு,
                            முதன்முறையாக ஒப்பிடக்கூடிய வடிவில்.
                        </li>
                        <li className="about__feature">
                            <strong className="about__feature-lead">
                                ஒரு குறள், இரு உலகக் காட்சிகள்.
                            </strong>{' '}
                            குறள் சமண நூலாகவும் வாசிக்கப்பட்டிருக்கிறது, இந்து நூலாகவும்
                            வாசிக்கப்பட்டிருக்கிறது — சில நேரம் ஒரே குறளில் இரண்டுமாக. அந்த
                            உரை மரபுகளின் வழிநடத்தப்பட்ட பயணம், வேறுபாடு ஆழமாக ஓடும்
                            இடங்களில் தொடங்கி.
                        </li>
                        <li className="about__feature">
                            <strong className="about__feature-lead">
                                குறளிடம் கேளுங்கள்.
                            </strong>{' '}
                            குறள்களிலும் உரைகளிலும் மட்டுமே ஊன்றி நிற்கும் ஓர் AI துணை —
                            ஒவ்வொரு பதிலும் தான் எங்கிருந்து வந்தது என்பதை உங்களுக்குக்
                            காட்டும் வகையில்.
                        </li>
                    </ul>
                </section>

                <p className="about__closing">
                    இத்தளம் தொடர்ந்து வளர்ந்துகொண்டே இருக்கும். இன்று நீங்கள் காண்பது
                    அடித்தளம்; முடிந்த வேலை அல்ல.
                </p>

                <section className="about__section" aria-labelledby="about-contact">
                    <h2 id="about-contact" className="about__section-title">
                        தொடர்பு கொள்ள
                    </h2>
                    <p className="about__contact">
                        <a
                            href="mailto:antonykanagu@gmail.com"
                            className="about__contact-link"
                        >
                            antonykanagu@gmail.com
                        </a>
                    </p>
                </section>

                <section className="about__section" aria-labelledby="about-feedback">
                    <h2 id="about-feedback" className="about__section-title">
                        கருத்துக்கள் அனுப்புங்கள்
                    </h2>
                    <p className="about__section-lede">
                        பிழை, ஆலோசனை, அல்லது வெறுமனே ஒரு வார்த்தை —
                        என்னாக இருந்தாலும் கேட்க விரும்புகிறேன்.
                    </p>
                    <FeedbackForm />
                </section>
            </article>
        );
    }

    return (
        <article className="about">
            <header className="about__head">
                <h1 className="about__title">Why this exists</h1>
            </header>

            <section className="about__prose" aria-label="Origin">
                <p>
                    I grew up around the Kural but never really read it — like a
                    lot of Tamil kids, I heard the same dozen couplets in school
                    and assumed I knew the whole thing. When I finally sat down
                    with it, I realised how much I'd been missing.
                </p>
                <p>
                    The Kural has lasted this long because people don't stop
                    coming back to it. Every century has produced its own
                    commentators, translators, and readers, and each one seems
                    to notice something the last generation didn't. This site is
                    me doing the same thing, just with the tools of my
                    generation instead of theirs.
                </p>
                <p>
                    It isn't a scholarly project — no institution, no funding,
                    no team. Just spare hours and a lot of curiosity about what
                    happens when you point modern tools at a 2,000-year-old
                    text. I built it because I wanted it to exist for myself; if
                    it's useful to anyone else, all the better.
                </p>
            </section>

            <p className="about__note">
                The texts used here are the ones time has made free for everyone:
                the original verses and the classical commentaries in the public
                domain.
            </p>

            <section className="about__section" aria-labelledby="about-now">
                <h2 id="about-now" className="about__section-title">
                    What is here now
                </h2>
                <p className="about__section-lede">
                    An interactive map of all 1,330 kurals. Each verse has been
                    read by an LLM and tagged with the themes it seems to touch;
                    the graph then links verses by how much theme they share —
                    same-chapter neighbours along one path, cross-chapter
                    thematic kin along another. The whole corpus is packaged in
                    Google's Open Knowledge Format (OKF), so the underlying data
                    lives as plain markdown on disk that anyone can read, fork,
                    or improve, rather than locked inside a database.
                </p>
            </section>

            <section className="about__section" aria-labelledby="about-coming">
                <h2 id="about-coming" className="about__section-title">
                    What is coming
                </h2>
                <ul className="about__features">
                    <li className="about__feature">
                        <strong className="about__feature-lead">
                            The commentators, side by side.
                        </strong>{' '}
                        The five surviving medieval commentaries aligned verse by
                        verse, with analysis of where they agree and where they
                        quietly part ways. Seven hundred years of interpretation,
                        made comparable at last.
                    </li>
                    <li className="about__feature">
                        <strong className="about__feature-lead">
                            One verse, two worldviews.
                        </strong>{' '}
                        The Kural has been read as a Jain text and as a Hindu one,
                        sometimes in the same verse. A guided exploration of those
                        interpretive traditions, starting where the divergence runs
                        deepest.
                    </li>
                    <li className="about__feature">
                        <strong className="about__feature-lead">
                            Ask the Kural.
                        </strong>{' '}
                        An AI companion grounded strictly in the verses and
                        commentaries themselves, so every answer can show you
                        exactly where it came from.
                    </li>
                </ul>
            </section>

            <p className="about__closing">
                This platform grows continuously. What you see today is the
                foundation, not the finished work.
            </p>

            <section className="about__section" aria-labelledby="about-contact">
                <h2 id="about-contact" className="about__section-title">
                    Get in touch
                </h2>
                <p className="about__contact">
                    <a
                        href="mailto:antonykanagu@gmail.com"
                        className="about__contact-link"
                    >
                        antonykanagu@gmail.com
                    </a>
                </p>
            </section>

            <section className="about__section" aria-labelledby="about-feedback">
                <h2 id="about-feedback" className="about__section-title">
                    Send feedback
                </h2>
                <p className="about__section-lede">
                    Spot a bug, have a suggestion, or just want to say
                    something? I read everything.
                </p>
                <FeedbackForm />
            </section>
        </article>
    );
}
